<div [formGroup]="form">
    <input matInput [ngxMatDatetimePicker]="picker1" placeholder="{{placeholder}}" ngClass="{{nameClass}}" formControlName="dateTime" [min]="minDate" [max]="maxDate" [required]="required" [errorStateMatcher]="matcher" (blur)="onTouched?.()">
    <div class="float-end button-right-input">
        <ngx-mat-datepicker-toggle matSuffix [for]="picker1" >
            <mat-icon ngxMatDatepickerToggleIcon>calendar_month</mat-icon>
        </ngx-mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker1 [enableMeridian]="is12hr"></ngx-mat-datetime-picker>
    </div>
</div>
